import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MediaRoutingModule } from './media-routing.module';
import { MediaComponent } from './media.component';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { SharedModule } from 'src/app/shared';
import { MediaListComponent } from './media-list/media-list.component';
import { MediaStatisticComponent } from './media-statistic/media-statistic.component';
import { MediaCreateComponent } from './media-create/media-create.component';
import { MediaUpdateComponent } from './media-update/media-update.component';
import {SelectMessageComponent} from "./media-create/select-message/select-message.component";

@NgModule({
  declarations: [
    MediaComponent,
    MediaListComponent,
    MediaStatisticComponent,
    MediaCreateComponent,
    MediaUpdateComponent,
    SelectMessageComponent
  ],
  imports: [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  MediaRoutingModule,
  NgZorroAntdModule,
  SharedModule,
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
})
export class MediaModule { }
